import React from 'react';
import styled from '@emotion/styled';

const StyledCTAModule = styled.div`
	h4 {
		font-size: ${(props) => (props.titleFontSize || '32') + 'px'};
		line-height: ${(props) => (props.titleLineHeight || '40') + 'px'};
		letter-spacing: 0.25px;
		color: ${(props) => props.titleColor || '#212121'};
	}

	p {
		font-size: 16px;
		line-height: 24px;
		letter-spacing: 0.15px;
		color: ${(props) => props.copyColor || '#545454'};
	}
`;

function CTAModule({
	props: {
		title,
		titleColor,
		titleAlignment,
		titleFontSize,
		titleLineHeight,
		copy,
		copyColor,
		copyAlignment,
		ctAs: { items },
	},
}) {
	return (
		<div className='container'>
			<StyledCTAModule
				titleColor={titleColor}
				copyColor={copyColor}
				titleFontSize={titleFontSize}
				titleLineHeight={titleLineHeight}
			>
				{title && <h4 className={'mb-20 text-' + titleAlignment}>{title}</h4>}
				{copy && <p className={'mb-20 text-' + copyAlignment}>{copy}</p>}
				{items.length > 0 ? (
					<div className='d-flex justify-content-center align-items-center flex-wrap'>
						{items.map((item, index) => {
							let { copy, link, style, newTab, hideInMobile, hideInDesktop } =
								item;
							if (copy && link) {
								return (
									<a
										key={index}
										href={link}
										rel='noreferrer'
										target={newTab ? '_blank' : '_self'}
										className={`m-10 btn btn-${style} ${
											hideInMobile
												? 'd-none d-md-inline-block'
												: hideInDesktop
												? 'd-inline-block d-md-none'
												: 'd-inline-block'
										}`}
									>
										{copy}
									</a>
								);
							}
						})}
					</div>
				) : null}
			</StyledCTAModule>
		</div>
	);
}

export default CTAModule;
